import { render, staticRenderFns } from "./MergeSummary.vue?vue&type=template&id=39d5eaaf&scoped=true&"
import script from "./MergeSummary.vue?vue&type=script&lang=js&"
export * from "./MergeSummary.vue?vue&type=script&lang=js&"
import style0 from "./MergeSummary.vue?vue&type=style&index=0&id=39d5eaaf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d5eaaf",
  null
  
)

export default component.exports